module.exports = __webpack_public_path__ + "static/media/11NEPAD9.1297cd1f.jpg";